module.exports = __webpack_public_path__ + "img/night.a3f3f38d.svg";